import styled from 'styled-components';

export const SearchForm = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    height: 10vh; 
    width: 80%;
`

export const StyledForm = styled.form`
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
`

export const LoupeIcon = styled.img`
    position: absolute;
    left: 20px;
    width: 24px;
    height: 24px;
`

export const SearchInput = styled.input`
    width: 100%;
    height: 50%;
    border: 3px solid black;
    border-radius: 25px;
    padding: 20px 20px 20px 70px;
    font-size: 16px;
`

